require('./retailLoanAddress.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @core
const { formatText } = require('core/i18n').i18n;

const { getTranslatedRoad } = require('constants/typeOfRoads');
// @Utilities
const { toCamelCase } = require('utilities/stringHelper');
const { formattedPhone } = require('utilities/personalDataHelper');
//@constants
const { retailLoanCommons: { COUNTRY } } = require('../../../../loansConstants/index');
// @ commons
const { OKLink } = require('commonsComponents/OKLink');

class RetailLoanAddress extends React.Component {

    constructor(props) {
        super(props);

        this.handleClickEditButton = this.handleClickEditButton.bind(this);
    }

    handleClickEditButton(e) {
        const { onHandleOpenEditModal } = this.props;
        e.preventDefault();
        e.stopPropagation();
        onHandleOpenEditModal();
    }

    formattedPhone() {
        const { immProfile } = this.props;
        const code = immProfile.getIn(['telefonoContacto', 'codigoPais']);
        const number = immProfile.getIn(['telefonoContacto', 'numero']);
        return formattedPhone(code, number);
    }

    buildEditButton() {
        const editText = formatText('contractRetailLoanStepTwo-contractRetailLoanStepTwo_editTitle');
        return (
            <OKLink
                extraClass="retail-loan-address__edit-link-button"
                modifier="emphasize"
                onClick={this.handleClickEditButton}
            >
                {editText}
            </OKLink>
        );
    }

    buildAddresWithoutInfo() {
        const {
            className,
            classNameItem,
            classNameWithoutBold,
            onHandleOpenEditModal,
            isThirdAddress,
        } = this.props;

        const titleEmptyBox = isThirdAddress ? formatText('contractRetailLoanStepTwo-contractRetailLoanStepTwo_titleOtherDeliveryAddress') :
            formatText('contractRetailLoanStepTwo-contractRetailLoanStepTwo_titleAddOtherAddress2');
        const messageEmptyBox = isThirdAddress ? formatText('contractRetailLoanStepTwo-contractRetailLoanStepTwo_subtitleOtherDeliveryAddress') :
            formatText('contractRetailLoanStepTwo-contractRetailLoanStepTwo_addOtherAddress2');

        return (
            <div className={className} onClick={onHandleOpenEditModal}>
                <i className="retail-loan-address__icon-add"></i>
                <div className="retail-loan-address__message-add-address">
                    <span className={classNameItem}>
                        {titleEmptyBox}
                    </span>
                    <span className={classNameWithoutBold}>
                        {messageEmptyBox}
                    </span>
                </div>
            </div>
        );
    }

    buildAddresWithInfo() {
        const {
            className,
            classNameItem,
            classNameWithoutBold,
            email,
            immAddress,
            mobileText,
            changeBillingAddress,
            isSecondAddress,
            isThirdAddress,
        } = this.props;

        let titleMessage = 'contractRetailLoanStepTwo-contractRetailLoanStepTwo_habitualAddress';
        if (isSecondAddress) {
            titleMessage = 'contractRetailLoanStepTwo-contractRetailLoanStepTwo_newDeliveryAddress2';
        } else if (isThirdAddress) {
            titleMessage = 'contractRetailLoanStepTwo-contractRetailLoanStepTwo_newBillingAddress';
        }

        const title = formatText(titleMessage);
        const phone = formatText(mobileText, [this.formattedPhone()]);
        const typeOfRoads = toCamelCase(getTranslatedRoad(immAddress.get('typeOfRoads')) || '');
        const streetName = toCamelCase(immAddress.get('streetName'));
        const numberStreet = immAddress.get('numberStreet');
        const restOfAddress = immAddress.get('restOfAddress') === '' ? '' :
            ', ' + toCamelCase(immAddress.get('restOfAddress'));
        const locality = toCamelCase(immAddress.get('locality'));

        const editButton = !!isSecondAddress || !!isThirdAddress ? this.buildEditButton() : null;
        const emailContainer = email ? (
            <span className={classNameItem}>
                {email}
            </span>
        ) : null;

        return (
            <div className={className} onClick={changeBillingAddress}>
                <span className={classNameWithoutBold}>
                    {title}
                </span>
                <span className={classNameItem}>
                    {`${typeOfRoads} ${streetName} ${numberStreet}${restOfAddress}`}
                </span>
                <span className={classNameItem}>
                    {`${locality}, ${COUNTRY}`}
                </span>
                <span className={classNameItem}>
                    {phone}
                </span>
                {editButton}
                {emailContainer}
            </div>
        );
    }

    render() {
        const {
            immAddress
        } = this.props;

        const addressSection = immAddress.get('typeOfRoads') !== 0 ?
            this.buildAddresWithInfo() : this.buildAddresWithoutInfo();

        return (
            <React.Fragment>
                {addressSection}
            </React.Fragment>
        );
    }
}

RetailLoanAddress.propTypes = {
    changeBillingAddress: PropTypes.func.isRequired,
    className: PropTypes.string,
    classNameItem: PropTypes.string,
    classNameWithoutBold: PropTypes.string,
    email: PropTypes.string,
    immAddress: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    isSecondAddress: PropTypes.bool,
    isThirdAddress: PropTypes.bool,
    mobileText: PropTypes.string.isRequired,
    onHandleOpenEditModal: PropTypes.func.isRequired
};

module.exports = RetailLoanAddress;
